export default __webpack_public_path__ + "static/villa1-c4491b47f9628d8d676c0e4969099c3a.jpeg";